/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { HistoryActionModel } from "./history-action.model";

export class HistoryModel {
  private _eventId: string;
  private _eventType: string;
  private _eventTargetType: string;
  private _changedBy: string;
  private _timestamp: Date;
  private _targetId: string;
  // Added in for the timeline as the logic is very overally complex once we have more than just projects-list
  // Also allows the timeline to get the name even of deleted projects-list, so it can be seen permanently
  private _targetName: string;
  private _historyActions: HistoryActionModel[];

  constructor(
    eventId?: string,
    eventType?: string,
    eventTargetType?: string,
    changedBy?: string,
    timestamp?: Date,
    targetId?: string,
    targetName?: string,
    historyActions?: HistoryActionModel[]
  ) {
    this._eventId = eventId;
    this._eventType = eventType;
    this._eventTargetType = eventTargetType;
    this._changedBy = changedBy;
    this._timestamp = timestamp;
    this._targetId = targetId;
    this._targetName = targetName;
    this._historyActions = historyActions;
  }

  get eventId(): string {
    return this._eventId;
  }

  set eventId(value: string) {
    this._eventId = value;
  }

  get eventType(): string {
    return this._eventType;
  }

  set eventType(value: string) {
    this._eventType = value;
  }

  get eventTargetType(): string {
    return this._eventTargetType;
  }

  set eventTargetType(value: string) {
    this._eventTargetType = value;
  }

  get changedBy(): string {
    return this._changedBy;
  }

  set changedBy(value: string) {
    this._changedBy = value;
  }

  get timestamp(): Date {
    return this._timestamp;
  }

  set timestamp(value: Date) {
    this._timestamp = value;
  }
  get targetId(): string {
    return this._targetId;
  }

  set targetId(value: string) {
    this._targetId = value;
  }
  get targetName(): string {
    return this._targetName;
  }

  set targetName(value: string) {
    this._targetName = value;
  }

  get historyActions(): HistoryActionModel[] {
    return this._historyActions;
  }

  set historyActions(value: HistoryActionModel[]) {
    this._historyActions = value;
  }

  toJson(): Object {
    const object = {
      event_id: this.eventId,
      event_type: this.eventType,
      event_target_type: this.eventTargetType,
      changed_by: this.changedBy,
      timestamp: this.timestamp,
      target_id: this._targetId,
      target_name: this._targetName
    };
    Object.keys(object).forEach(k => !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): HistoryModel {
    return new HistoryModel(
      input['event_id'],
      input['event_type'],
      input['event_target_type'],
      input['changed_by'],
      input['timestamp'],
      input['target_id'],
      input['target_name']
    );
  }
}
